import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { Spinner } from '@amglobal/ui-shared'
import { AppPaths } from '@/config/app-paths'
import { isAuthenticated } from '@/features/auth/session/workspace-session'

export function RequireAuth() {
  const location = useLocation()

  if (!isAuthenticated()) {
    const returnUrl = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`${AppPaths.login}?returnUrl=${returnUrl}`} replace />
  }

  return <Outlet />
}

export function AuthLoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-workspace">
      <Spinner className="h-8 w-8 text-brand-primary" />
    </div>
  )
}
